<template>
    <div class="row give-access-employees-groups-list mt-4">
        <div class="col-xl-6 col-xxl-6 col-lg-7 col-md-12 p-lr-0-sm">
            <div class="row multisteps-form categories">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 p-lr-0-sm">
                    <div class="dis-flex flex-m flex-sb multisteps-form__content mb-2 pr-3">
                        <div class="dis-flex flex-m">
                            <i class="uis uis-users-alt mr-1 mb-2 text-rose"></i>
                            <label>Access for Employees by Groups</label>
                        </div>
                    </div>
                    <div class="multisteps-form__form dis-flex flex-column">
                        <div class="card pl-3 pr-3 dis-flex flex-column mb-2 multisteps-form__content">
                            <i class="uis uis-circle pos-absolute fs-4 text-blue rt-1-1r"></i>
                            <div class="row">
                                <div class="col-sm-12 p-lr-0-sm">
                                    <div class="dis-flex col-12 p-0">
                                        <div class="dis-flex col-sm-12 p-0">
                                            <div class="col-sm-9 col-md-9 col-xl-9 col-lg-9 pt-1 pb-1 pl-0 dis-flex flex-m">
                                                <span class="job-title pt-1 pb-1">Sellers</span>
                                            </div>
                                            <div class="col-sm-2 col-2 pl-0 dis-flex flex-m"></div>
                                            <div class="col-sm-1 col-1 p-0 dis-flex flex-m flex-r">
                                                <div class="buttons-whatch-attirute">
                                                    <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Edit Category">
                                                        <i class="uis uis-edit-alt fs-11"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card pl-3 pr-3 dis-flex flex-column mb-2 multisteps-form__content">
                            <i class="uis uis-circle pos-absolute fs-4 text-blue rt-1-1r"></i>
                            <div class="row">
                                <div class="col-sm-12 p-lr-0-sm">
                                    <div class="dis-flex col-12 p-0">
                                        <div class="dis-flex col-sm-12 p-0">
                                            <div class="col-sm-9 col-md-9 col-xl-9 col-lg-9 pt-1 pb-1 pl-0 dis-flex flex-m">
                                                <span class="job-title pt-1 pb-1">Administrators</span>
                                            </div>
                                            <div class="col-sm-2 col-2 pl-0 dis-flex flex-m"></div>
                                            <div class="col-sm-1 col-1 p-0 dis-flex flex-m flex-r">
                                                <div class="buttons-whatch-attirute">
                                                    <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Edit Category">
                                                        <i class="uis uis-edit-alt fs-11"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>